var _mask, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_857_68800",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18Z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18C31.5 25.4558 25.4558 31.5 18 31.5V34.5C27.1127 34.5 34.5 27.1127 34.5 18H31.5ZM18 31.5C10.5442 31.5 4.5 25.4558 4.5 18H1.5C1.5 27.1127 8.8873 34.5 18 34.5V31.5ZM4.5 18C4.5 10.5442 10.5442 4.5 18 4.5V1.5C8.8873 1.5 1.5 8.8873 1.5 18H4.5ZM18 4.5C25.4558 4.5 31.5 10.5442 31.5 18H34.5C34.5 8.8873 27.1127 1.5 18 1.5V4.5Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_857_68800)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18L15 24L15 12L24 18Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.830a254e.svg";
export { ForwardRef as ReactComponent };